import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { selectCurrentDashboardFields, setFilterAppearence } from "@/pages/dashboard/dashboard.slice";

const LayoutToggleComponent = ({ block = false, value, onChange }) => {
  const dispatch = useDispatch();
  const defaultSideView = useSelector(state => state.userDetails.setting.newVersion);
  const { sideView } = useSelector(selectCurrentDashboardFields);
  const resolvedSideView = typeof value === "boolean"
    ? value
    : (typeof sideView === "boolean" ? sideView : defaultSideView);

  const setFilterSideView = (nextSideView) => {
    if (typeof value !== "boolean" && sideView !== nextSideView) {
      dispatch(setFilterAppearence(nextSideView));
    }
    onChange && onChange(nextSideView);
  };

  return (
    <Radio.Group
      block={block}
      value={resolvedSideView ? "right" : "top"}
      onChange={(event) => setFilterSideView(event.target.value === "right")}
    >
      <Radio.Button
        value="right"
        aria-label="Filters on the side"
      >
        <i className="ri-layout-right-line" />
      </Radio.Button>
      <Radio.Button
        value="top"
        aria-label="Filters on top"
      >
        <i className="ri-layout-top-line" />
      </Radio.Button>
    </Radio.Group>
  );
};

export default LayoutToggleComponent;
